document.addEventListener('alpine:init', () => {
  // No search UI in theme Liquid — Shopify/asset cache or apps sometimes still emit
  // handlers like `$store.search.show = false`. This stub prevents Alpine exceptions.
  Alpine.store('search', {
    query: '',
    show: false,
    explicitlyOpened: false,
    results: [],
    collections: [],
    articles: [],
    pages: [],
    suggestions: [],
    hideSuggestions: false,
  });

  // Older markup or cached HTML may still call `$store.nav.closeDropdown()` / `openDropdown`.
  Alpine.store('nav', {
    activeDropdownIndex: null,
    openDropdown(index) {
      this.activeDropdownIndex = index;
    },
    closeDropdown() {
      this.activeDropdownIndex = null;
    },
  });

  Alpine.data('layoutShell', ({ cartCount } = {}) => ({
    drawerOpen: false,
    cartCount: cartCount ?? 0,
    closeModal() {
      document.dispatchEvent(new CustomEvent('close-modals'));
    },
    async fetchCart() {
      const root =
        window.Shopify?.routes?.root != null ? window.Shopify.routes.root : '/';
      const res = await fetch(`${root}cart.js`);
      const data = await res.json();
      this.cartCount = data.item_count;
      return data;
    },
  }));
});
